import { LazyRenderLayer } from 'core/layouts/ui-blocks/ReusableComponents';
import { ComponentLoadingScreen } from 'core/navigation/loading-screen/LoadingScreen';
import { homeProductPhotoModalSelector } from 'core/store/reducers/homeReducer/HomeSlice';
import React, { lazy, Suspense } from 'react';
import { useSelector } from 'react-redux';

const ProductPhotoModal = lazy(() => import('./ProductPhotoModal'));

function LazyProductPhotoModal() {
	const isModalOpen = useSelector(homeProductPhotoModalSelector);

	return (
		<LazyRenderLayer isShown={isModalOpen}>
			<Suspense fallback={<ComponentLoadingScreen />}>
				<ProductPhotoModal />
			</Suspense>
		</LazyRenderLayer>
	);
}

export default LazyProductPhotoModal;
